import $ from 'jquery';

export class NestedSelector {

    data;
    inputs;
    values;
    allowNull;

    constructor(inputs, data, allowNull = false) {
        this.data = data;
        this.inputs = inputs;
        this.values = [];
        this.allowNull = allowNull;

        for (let [index, input] of this.inputs.entries()) {
            this.values[index] = $(input).data('selected-value');

            $(input).change(_ => {
                this.values[index] = $(input).val();
                this.updateSelections(this.data, 0);
            })
        }

        this.updateSelections(this.data, 0);
    }

    updateSelections(items, index) {
        if (index === 0) {
            // disable all selections
            for (let input of this.inputs) {
                this.disableSelection($(input));
            }
        }

        const input = $(this.inputs[index]);
        const value = this.values[index];
        this.updateSelection(input, value, items);
        if (value === '') {
            return;
        }

        const item = this.getItem(items, value);

        if (!item) {
            // selected value is invalid, reset current input
            this.values[index] = '';
            this.updateSelections(items, index);
            return;
        }

        if (item.leaf === true || !item.hasOwnProperty('items')) {
            // selected value is a leaf, stop.
            return;
        }

        // next index
        this.updateSelections(item.items, ++index);
    }

    updateSelection(selection, selected, list) {
        selection.prop('disabled', false);

        selection.empty();
        selection.append('<option value="" ' + (this.allowNull ? '' : 'disabled') + ' ' + (selected === '' ? 'selected' : '') + '>Maak een keuze</option>');
        for (let i in list) {
            const properties = list[i].id == selected ? 'selected' : '';
            selection.append('<option value="' + list[i].id + '" ' + properties + '>' + list[i].name + '</option>');
        }
    }

    disableSelection(selection) {
        selection.prop('disabled', true);
    }

    getItem(list, id) {
        return list.filter((item) => item.id == id)[0];
    }

}
